import { useLocalStorageState } from 'ahooks';
import { StateArray } from './StateArrayType';
import { FlagCountry } from '../components/Flag/Flag';

export const useSystemCountriesState = (): StateArray<FlagCountry[]|undefined> => (
  useLocalStorageState('selectedCountries') as StateArray<FlagCountry[]|undefined>
);
